export default function PoliticaDeConfidentialitate() {
	return (
		<>
			<div className='col-lg-12'>
				<div className='container'>
					<p>
						POLITICA DE CONFIDENȚIALITATE
						<br />
						Operatorul de date
					</p>
					<p>Operatorul responsabil pentru prelucrarea datelor cu caracter personal este:</p>
					<p>
						&ldquo;ALL CONSULTING LASCU&rdquo; S.R.L. (denumită &icirc;n continuare &bdquo;All Consulting&rdquo;
						sau &bdquo;Operatorul&rdquo;),
						<br />
						cu sediul &icirc;n mun. Sibiu, Cisnadie, Str. Grigore Ionescu 2 Ap. 2C Cod 555300,
						<br />
						&icirc;nregistrată la Registrul Comerțului sub nr. J32/1568/2023 ,
						<br />
						Cod unic de &icirc;nregistrare: 48688428.
					</p>
					<p>
						All Consulting prelucrează datele cu caracter personal &icirc;n calitate de operator, &icirc;n
						conformitate cu dispozițiile Regulamentului (UE) 2016/679 privind protecția persoanelor
						fizice &icirc;n ceea ce privește prelucrarea datelor cu caracter personal
						(&bdquo;GDPR&rdquo;) și legislației naționale aplicabile &icirc;n materie de protecția
						datelor.
					</p>
					<p>
						Protejarea datelor dvs. cu caracter personal este o prioritate pentru noi. Respectăm
						confidențialitatea utilizatorilor și ne angajăm să asigurăm securitatea datelor colectate
						prin intermediul aplicației mobile, site-ului web și altor canale de interacțiune.
					</p>
					<p>
						Prin utilizarea aplicației, site-ului sau a serviciilor noastre, confirmați că ați citit
						și ați &icirc;nțeles prezenta Politică de confidențialitate. &Icirc;n situațiile &icirc;n
						care legea impune consimțăm&acirc;nt explicit pentru anumite prelucrări, vă vom solicita
						acest consimțăm&acirc;nt &icirc;n mod separat.
					</p>
					<p>
						Această Politică poate fi modificată periodic. Cea mai recentă versiune este disponibilă
						la:
						<br />
						👉 https://app.all-consulting-lascu.ro/politica-de-confidentialitate
					</p>
					<p>
						Pentru &icirc;ntrebări sau solicitări privind protecția datelor cu caracter personal, ne
						puteți contacta la adresa:
						<br />
						📧 [contact@all-consulting-lascu.ro]
					</p>
					<p>
						Vă atragem atenția că site-ul și aplicația All Consulting pot conține linkuri către terți (de
						ex. parteneri, rețele sociale, platforme externe), care pot avea politici de
						confidențialitate proprii. Vă recomandăm să le consultați &icirc;nainte de a furniza date
						personale către acele entități.
					</p>
					<p>ANEXĂ PRIVIND PROTECȚIA DATELOR CU CARACTER PERSONAL</p>
					<p>
						Prezentele Condiții Generale privind protecția datelor cu caracter personal (denumite
						&icirc;n continuare &bdquo;Anexa privind Protecția Datelor&rdquo;) reglementează
						procedurile și principiile aplicabile prelucrării datelor personale ale Clienților și fac
						parte integrantă din orice contract de prestări servicii (denumit &icirc;n continuare
						&bdquo;Contractul&rdquo;) &icirc;ncheiat &icirc;ntre orice Client și ALL CONSULTING LASCU S.R.L.
						(denumită &icirc;n continuare &bdquo;Furnizor&rdquo; sau &bdquo;All Consulting&rdquo;), cu
						sediul &icirc;n mun. mun. Sibiu, Cisnadie, Str. Grigore Ionescu 2 Ap. 2C Cod 555300, Rom&acirc;nia, &icirc;nregistrată &icirc;n Registrul Comerțului sub nr.
						J32/1568/2023 , av&acirc;nd Cod unic de &icirc;nregistrare 48688428.
					</p>
					<p>
						Termenii utilizați &icirc;n prezenta Anexă vor avea sensul definit &icirc;n cadrul
						acesteia sau, dacă nu este definit &icirc;n mod expres, sensul prevăzut &icirc;n Contract.
						Cu excepția modificărilor prevăzute expres de prezenta Anexă, toate celelalte prevederi
						ale Contractului răm&acirc;n &icirc;n vigoare și pe deplin aplicabile.
					</p>
					<p>
						Av&acirc;nd &icirc;n vedere obligațiile reciproce asumate, părțile convin ca termenii și
						condițiile prevăzute &icirc;n această Anexă să fie considerate parte inseparabilă a
						Contractului.
					</p>
					<p>
						1. DEFINIȚII
						<br />
						1.1. Prelucrare &ndash; orice operațiune sau set de operațiuni efectuate asupra Datelor cu
						caracter personal, cu sau fără utilizarea unor mijloace automatizate, inclusiv, dar fără a
						se limita la: colectarea, &icirc;nregistrarea, organizarea, structurarea, stocarea,
						modificarea, consultarea, utilizarea, divulgarea, ștergerea sau distrugerea acestora.
					</p>
					<p>
						1.2. Operator &ndash; persoana fizică sau juridică, autoritate publică sau orice altă
						entitate care stabilește scopurile și mijloacele de prelucrare a datelor cu caracter
						personal. &Icirc;n sensul prezentei Anexe, Operatorul este ALL CONSULTING LASCU S.R.L., denumită
						și &bdquo;All Consulting&rdquo;.
					</p>
					<p>
						1.3. Client (Dumneavoastră) &ndash; persoana fizică ce utilizează, a utilizat sau a
						manifestat intenția de a utiliza Serviciile furnizate de All Consulting.
					</p>
					<p>
						1.4. Persoană &icirc;mputernicită de operator &ndash; persoana fizică/juridică sau
						entitate care prelucrează date cu caracter personal &icirc;n numele Operatorului.
					</p>
					<p>
						1.5. Date cu caracter personal &ndash; orice informații privind o persoană fizică
						identificată sau identificabilă, inclusiv, dar fără a se limita la: nume, CNP, număr de
						telefon, adresă de e-mail, date bancare, cod de client, identificatori online, etc.
					</p>
					<p>
						1.6. &Icirc;ncălcarea securității datelor &ndash; orice incident care duce la
						compromiterea confidențialității, integrității sau disponibilității datelor cu caracter
						personal, inclusiv accesul neautorizat, pierderea, distrugerea sau divulgarea
						accidentală/ilegală a acestora.
					</p>
					<p>
						1.7. Autoritate de supraveghere &ndash; autoritatea publică independentă responsabilă cu
						monitorizarea aplicării legislației privind protecția datelor (&icirc;n Rom&acirc;nia:
						Autoritatea Națională de Supraveghere a Prelucrării Datelor cu Caracter Personal &ndash;
						ANSPDCP).
					</p>
					<p>
						1.8. Clauze contractuale standard &ndash; clauzele aprobate de Comisia Europeană pentru
						transferul datelor către țări terțe care nu asigură un nivel adecvat de protecție.
					</p>
					<p>
						1.9. Consimțăm&acirc;nt &ndash; orice manifestare de voință liberă, specifică, informată
						și lipsită de ambiguitate a persoanei vizate prin care aceasta acceptă prelucrarea datelor
						sale.
					</p>
					<p>
						1.10. Date personale ale Clientului &ndash; orice date personale furnizate sau colectate
						de la Client &icirc;n scopul prestării Serviciilor &icirc;n baza Contractului.
					</p>
					<p>
						1.11. Categorii speciale de date &ndash; date ce dezvăluie aspecte sensibile precum:
						origine rasială/etnică, opinii politice, convingeri religioase sau filosofice, starea de
						sănătate, orientare sexuală etc.
					</p>
					<p>
						1.12. Destinatar &ndash; orice persoană fizică/juridică sau autoritate căreia i se divulgă
						datele, cu excepția autorităților publice care le solicită conform legii &icirc;n
						contextul unei anchete.
					</p>
					<p>
						1.13. Legislația aplicabilă &ndash; include GDPR, Legea nr. 190/2018 (Rom&acirc;nia) și
						alte reglementări relevante la nivel național și european &icirc;n vigoare.
					</p>
					<p>
						1.14. Număr de identificare &ndash; orice cod care permite identificarea unică a unei
						persoane (ex: CNP, număr de telefon, IP, cod client).
					</p>
					<p>
						1.15. Număr de identificare național &ndash; identificatori oficiali recunoscuți la nivel
						național, cum ar fi CNP, seria și numărul actului de identitate, coduri de asigurare
						socială etc.
					</p>
					<p>
						1.16. Pseudonimizare &ndash; prelucrarea datelor &icirc;ntr-un mod care le face imposibil
						de atribuit unei persoane vizate fără informații suplimentare, păstrate separat și
						securizate.
					</p>
					<p>
						1.17. Parte terță &ndash; orice entitate sau persoană care nu este persoana vizată,
						operatorul sau persoana &icirc;mputernicită și care nu acționează sub autoritatea directă
						a acestora.
					</p>
					<p>
						1.18. Restricționarea prelucrării &ndash; marcarea datelor pentru a limita utilizarea
						acestora &icirc;n viitor.
					</p>
					<p>
						1.19. Servicii &ndash; serviciile oferite de All Consulting &icirc;n baza Contractului,
						inclusiv cele furnizate prin aplicație, website sau call center.
					</p>
					<p>
						<br />
						2. PRINCIPII PRIVIND PROTECȚIA DATELOR CU CARACTER PERSONAL
						<br />
						All Consulting se angajează să respecte principiile fundamentale privind prelucrarea datelor
						cu caracter personal, conform prevederilor Regulamentului (UE) 2016/679
						(&bdquo;GDPR&rdquo;) și legislației naționale aplicabile. Astfel, prelucrarea datelor se
						va realiza cu respectarea următoarelor principii:
					</p>
					<p>
						Legalitate, echitate și transparență &ndash; Datele cu caracter personal sunt prelucrate
						&icirc;n mod legal, echitabil și transparent față de persoana vizată. &Icirc;nainte de
						&icirc;nceperea oricărei activități de prelucrare, vă vom informa cu privire la scopul și
						temeiul legal al prelucrării și vom ține cont de drepturile dumneavoastră.
						<br /> <br /> Limitarea scopului &ndash; Datele sunt colectate &icirc;n scopuri
						determinate, explicite și legitime și nu vor fi prelucrate ulterior &icirc;ntr-un mod
						incompatibil cu aceste scopuri.
						<br /> <br /> Reducerea la minimum a datelor &ndash; Prelucrăm numai datele strict
						necesare, relevante și adecvate &icirc;n raport cu scopurile pentru care sunt colectate și
						ulterior prelucrate.
						<br /> <br /> Limitarea stocării &ndash; Datele cu caracter personal vor fi păstrate doar
						at&acirc;t timp c&acirc;t este necesar pentru &icirc;ndeplinirea scopurilor pentru care au
						fost colectate, cu excepția cazurilor &icirc;n care legislația aplicabilă sau interesele
						legitime justifică o perioadă mai lungă de stocare.
						<br /> <br /> Acuratețe &ndash; Vom lua măsuri rezonabile pentru a ne asigura că datele
						prelucrate sunt corecte, actuale și, acolo unde este cazul, vor fi rectificate sau șterse
						fără &icirc;nt&acirc;rziere.
						<br /> <br /> Integritate și confidențialitate &ndash; Datele vor fi prelucrate
						&icirc;ntr-un mod care asigură securitatea adecvată, inclusiv protecția &icirc;mpotriva
						prelucrării neautorizate sau ilegale, a pierderii, distrugerii sau deteriorării
						accidentale, prin aplicarea de măsuri tehnice și organizatorice corespunzătoare.
						<br /> <br />
						3. DATELE CU CARACTER PERSONAL ȘI SCOPUL DE PRELUCRARE
						<br />
						Categorii de date colectate
						<br />
						&Icirc;n vederea furnizării serviciilor noastre, inclusiv intermedierea rambursării
						taxelor &icirc;n numele Clienților persoane fizice, All Consulting poate colecta și prelucra
						următoarele categorii de date cu caracter personal:
					</p>
					<p>
						Nume și prenume;
						<br /> Număr de telefon;
						<br /> Adresă de domiciliu/reședință și adresă de corespondență;
						<br /> Adresă de e-mail;
						<br /> Adresă IP și date tehnice aferente dispozitivului;
						<br /> Stare civilă;
						<br /> Date din actele de identitate (carte de identitate/pașaport): seria, numărul, data
						emiterii și expirării, autoritatea emitentă, numele părinților, locul și data nașterii;
						<br /> Cod numeric personal (CNP);
						<br /> Cetățenie și statut de rezidență (inclusiv rezidență fiscală);
						<br /> Date bancare (ex: număr cont IBAN);
						<br /> Informații despre angajatori și istoricul angajărilor;
						<br /> Venituri realizate, impozite achitate, alocații și alte compensații;
						<br /> Informații privind membrii familiei (soț/soție, copii &icirc;n &icirc;ntreținere);
						<br /> Semnătura și, unde este cazul, copia documentelor justificative.
						<br />
						Principiul minimizării
					</p>
					<p>
						&Icirc;n măsura &icirc;n care, conform cerințelor autorităților fiscale din țara
						relevantă, executarea Contractului nu mai necesită colectarea unor anumite date, acele
						date nu vor fi colectate sau prelucrate de către All Consulting. Prelucrăm exclusiv datele
						necesare &icirc;ndeplinirii scopurilor legitime și legale definite mai jos.
					</p>
					<p>
						Scopurile prelucrării
						<br />
						All Consulting prelucrează datele cu caracter personal ale Clienților &icirc;n următoarele
						scopuri:
					</p>
					<p>
						&Icirc;ncheierea și executarea contractului, inclusiv:
						<br /> completarea și depunerea declarațiilor fiscale;
						<br /> furnizarea documentelor necesare rambursării impozitului;
						<br /> comunicarea și asistența pe durata procesului fiscal;
						<br /> procesarea plăților și facturarea.
						<br /> <br /> &Icirc;ndeplinirea obligațiilor legale ce revin All Consulting conform
						legislației naționale și europene aplicabile (ex: arhivarea documentelor financiare,
						răspunsuri către autorități).
						<br /> <br /> Interesul legitim al All Consulting, cum ar fi:
						<br /> analiză internă și &icirc;mbunătățirea serviciilor;
						<br /> dezvoltarea funcționalităților aplicației;
						<br /> prevenirea fraudelor;
						<br /> gestionarea riscurilor operaționale;
						<br /> transmiterea de comunicări comerciale generale sau personalizate, inclusiv
						materiale informative sau campanii de loializare.
						<br />
						Corelarea volumului de date cu serviciile accesate
					</p>
					<p>Volumul exact de date personale colectate și prelucrate de All Consulting depinde de:</p>
					<p>
						Serviciile comandate;
						<br /> Tipul relației contractuale existente cu Clientul;
						<br /> Legislația și cerințele specifice din statul din care se solicită rambursarea
						taxelor.
						<br />
						All Consulting va adapta prelucrarea datelor cu caracter personal la cerințele legislative ale
						fiecărui stat &icirc;n parte și va acționa &icirc;n permanență &icirc;n limitele prevăzute
						de Regulamentul (UE) 2016/679 (GDPR).
					</p>
					<p>
						3.1. Date furnizate de Client
						<br />
						3.1.1. Colectarea și prelucrarea datelor &icirc;n cursul executării Contractului
						<br />
						&Icirc;n vederea furnizării serviciilor contractate, &icirc;n special a celor legate de
						recuperarea sumelor din impozitele achitate, completarea și depunerea declarațiilor
						fiscale, precum și &icirc;ndeplinirea obligațiilor legale și fiscale relevante, All Consulting
						prelucrează următoarele categorii de date cu caracter personal:
					</p>
					<p>
						a) Date de identificare:
						<br /> Nume, prenume, al doilea prenume;
						<br /> Cod numeric personal (CNP), data și locul nașterii, cetățenia;
						<br /> Cod de contribuabil (număr identificare fiscală națională/internațională);
						<br /> Date din documente de identitate (seria, numărul, data emiterii și expirării,
						autoritatea emitentă), inclusiv copii ale acestora;
						<br /> Fotografie (dacă este inclusă &icirc;n documente justificative);
						<br /> Semnătura.
						<br />
						b) Date de contact:
						<br /> Adresă de domiciliu și/sau reședință;
						<br /> Adresă de corespondență;
						<br /> Număr de telefon;
						<br /> Adresă de e-mail.
						<br /> <br />
						c) Date profesionale și fiscale:
						<br /> Angajatori, funcție ocupată, natura muncii;
						<br /> Vechimea &icirc;n muncă, veniturile &icirc;ncasate, impozite și contribuții
						plătite;
						<br /> Alocații și beneficii sociale;
						<br /> Număr de &icirc;nregistrare la asigurările sociale;
						<br /> Cod de identificare fiscală &icirc;n statul de muncă;
						<br /> Date privind certificatele de activitate (ex. Gewerbe);
						<br /> Alte informații solicitate de autoritățile fiscale din țara din care se solicită
						rambursarea.
						<br /> <br />
						d) Date privind situația familială:
						<br /> Stare civilă;
						<br /> Informații despre soț/soție, copii minori (&icirc;n &icirc;ntreținere);
						<br /> Copii ale certificatelor de căsătorie, naștere, alte documente justificative.
						<br /> <br />
						e) Date financiare:
						<br /> Numărul contului bancar (IBAN);
						<br /> Alte date bancare necesare pentru efectuarea plății sumelor rambursate.
						<br /> <br />
						f) Date tehnice și de utilizare:
						<br /> Adresă IP, sistem de operare, browser, informații despre sesiune;
						<br /> Adresa URL de referință, coduri de eroare, ID-ul dispozitivului mobil;
						<br /> Datele transmise de App Store / Google Play &icirc;n procesul de instalare (ex.
						nume utilizator, e-mail, oră descărcare);
						<br /> Aceste date sunt prelucrate doar &icirc;n măsura &icirc;n care sunt necesare pentru
						funcționarea aplicației. Temeiul legal este art. 6 alin. (1) lit. b GDPR (executarea unui
						contract).
						<br /> <br />
						g) Date de utilizare a aplicației:
						<br /> Informațiile completate &icirc;n aplicație pentru generarea declarației fiscale;
						<br /> PDF-ul declarației fiscale (Elster PDF) &ndash; disponibil &icirc;n contul
						utilizatorului și transmis la adresa de e-mail furnizată;
						<br /> Evaluarea fiscală electronică obținută de la autoritatea fiscală germană (pentru
						verificare, statistici și optimizarea serviciilor);
						<br /> Datele sunt păstrate pe durata existenței contului, cu opțiune de ștergere la
						cerere.
						<br /> <br />
						h) Date privind tranzacțiile:
						<br /> Informații despre plățile efectuate pentru serviciile prestate (ex. dată, sumă,
						confirmare);
						<br /> Procesatorii de plăți terți (EuPlătesc.ro, Stripe, Revolut) primesc numele și
						datele bancare pentru a finaliza tranzacția;
						<br /> All Consulting nu stochează datele de plată, ci doar informațiile tranzacționale
						relevante &icirc;n scop de raportare contabilă. Acestea sunt păstrate timp de 10 ani
						conform obligațiilor legale;
						<br /> Temeiul legal este art. 6 alin. (1) lit. b și lit. c GDPR.
						<br />
						i) Prelucrarea prin ELSTER:
						<br /> Declarațiile fiscale sunt transmise prin sistemul ELSTER (platforma oficială a
						fiscului german);
						<br /> Software-ul colectează, pe l&acirc;ngă datele fiscale, informații tehnice precum
						sistemul de operare, pentru validarea și securizarea transmiterii;
						<br /> Temeiurile legale: art. 6 alin. (1) lit. b și lit. a, art. 9 alin. (2) lit. a GDPR,
						și art. 6 alin. (3) lit. b GDPR &ndash; &icirc;n conformitate cu legislația fiscală
						germană.
						<br />
						j) Asistență și suport:
						<br /> Datele furnizate de Client atunci c&acirc;nd contactează echipa de suport (ex:
						nume, e-mail, detalii tehnice despre aplicație);
						<br /> Temeiul legal: art. 6 alin. (1) lit. b GDPR (necesar pentru executarea
						contractului).
						<br />
						k) Marketing și comunicări comerciale:
						<br /> &Icirc;n baza consimțăm&acirc;ntului exprimat (art. 6 alin. (1) lit. a GDPR) sau
						interes legitim (art. 6 alin. (1) lit. f GDPR), putem trimite:
						<br /> <br /> newslettere, oferte personalizate, sondaje, notificări despre
						&icirc;mbunătățiri ale serviciului.
						<br />
						l) Alte date necesare:
						<br /> Informații despre data sosirii și plecării din țara &icirc;n care se solicită
						rambursarea taxelor;
						<br /> Documente adiționale solicitate de autorități sau angajatori, transmise de
						utilizator sau obținute cu acordul acestuia.
						<br />
						3.1.2. Date colectate prin intermediul website-ului
						<br />
						&Icirc;n cazul &icirc;n care accesați site-ul nostru oficial, www.all-consulting-lascu.ro, și
						completați formularele de contact, este posibil să ne furnizați date cu caracter personal
						precum:
					</p>
					<p>
						Nume și prenume;
						<br /> Număr de telefon;
						<br /> Adresă de e-mail;
						<br /> Adresa IP;
						<br /> User și parolă (&icirc;n cazul autentificării printr-un cont de utilizator).
						<br />
						Aceste date sunt colectate pentru a vă putea răspunde solicitărilor, pentru a furniza
						informații despre serviciile noastre sau pentru a facilita crearea unui cont &icirc;n
						aplicație.
					</p>
					<p>Prelucrarea acestor date se bazează pe:</p>
					<p>
						Art. 6 alin. (1) lit. b GDPR &ndash; executarea unui contract sau pași premergători
						&icirc;ncheierii acestuia;
						<br /> Art. 6 alin. (1) lit. f GDPR &ndash; interesul legitim al Operatorului de a oferi
						răspunsuri prompte și servicii eficiente;
						<br /> Art. 6 alin. (1) lit. a GDPR, dacă ne-ați acordat consimțăm&acirc;ntul expres
						pentru prelucrarea acestor date &icirc;n scopuri specifice.
						<br />
						3.1.3. Date prelucrate &icirc;n scop de marketing direct
						<br />
						All Consulting poate prelucra datele dvs. cu caracter personal &icirc;n scop de marketing
						direct &ndash; inclusiv transmiterea de oferte personalizate, informații despre produse și
						servicii noi, sau sondaje privind satisfacția &ndash; doar &icirc;n baza
						consimțăm&acirc;ntului expres exprimat de dvs.
					</p>
					<p>Datele prelucrate &icirc;n acest scop pot include:</p>
					<p>
						Nume, prenume;
						<br /> Data nașterii;
						<br /> Cod numeric personal (CNP);
						<br /> Date din documente de identitate;
						<br /> Adresă de domiciliu și/sau reședință;
						<br /> Adresă de e-mail;
						<br /> Număr de telefon.
						<br />
						Prelucrarea acestor date &icirc;n scopuri de marketing nu este obligatorie pentru
						accesarea serviciilor oferite de All Consulting, iar consimțăm&acirc;ntul poate fi retras
						&icirc;n orice moment, fără consecințe asupra relației contractuale existente.
					</p>
					<p>
						3.1.4. Date colectate prin conectare la conturi terțe (rețele sociale)
						<br />
						All Consulting oferă posibilitatea de a accesa serviciile noastre prin autentificare cu
						conturi de social media, inclusiv:
					</p>
					<p>
						Facebook
						<br /> Instagram
						<br /> TikTok
						<br />
						Dacă optați pentru această metodă de conectare, All Consulting poate colecta date deja
						asociate contului dvs. de pe rețeaua socială respectivă, cum ar fi:
					</p>
					<p>
						Numele complet;
						<br /> Adresa de e-mail;
						<br /> ID de utilizator.
						<br />
						Accesul și prelucrarea acestor date sunt limitate la ceea ce este permis de setările de
						confidențialitate din platforma socială și sunt utilizate exclusiv pentru a facilita
						&icirc;nregistrarea și autentificarea &icirc;n aplicația All Consulting.
					</p>
					<p>
						3.2. Date primite de la terți
						<br />
						3.2.1. Informații furnizate de instituții publice sau alți parteneri
						<br />
						&Icirc;n vederea &icirc;ndeplinirii obligațiilor contractuale asumate față de Client, este
						posibil ca All Consulting să primească date personale referitoare la dvs. de la surse externe,
						inclusiv:
					</p>
					<p>
						Autorități și instituții publice din Rom&acirc;nia, Germania sau alte state implicate
						&icirc;n procesul fiscal;
						<br /> Angajatori sau parteneri contractuali;
						<br /> Furnizori de servicii externe implicați &icirc;n procesarea cererilor fiscale.
						<br />
						Aceste date sunt prelucrate exclusiv pentru scopurile pentru care au fost furnizate,
						&icirc;n temeiul executării contractului și/sau &icirc;n baza obligațiilor legale &icirc;n
						vigoare.
					</p>
					<p>
						4. ACCESAREA PAGINII WEB
						<br />
						La fiecare accesare a website-ului nostru, www.all-consulting-lascu.ro, anumite date tehnice sunt
						colectate automat și stocate temporar &icirc;n fișiere jurnal (log-uri de server). Aceste
						date pot include:
					</p>
					<p>
						Adresa IP a dispozitivului utilizat pentru accesarea site-ului;
						<br /> Regiunea geografică generală de unde se realizează conexiunea;
						<br /> Data și ora accesului;
						<br /> Tipul și versiunea browserului;
						<br /> Sistemul de operare utilizat;
						<br /> URL-ul paginii vizitate și URL-ul de referință;
						<br /> Istoricul de navigare pe paginile site-ului nostru;
						<br /> Erori de &icirc;ncărcare, coduri de stare HTTP, dimensiunea fișierelor accesate.
						<br />
						4.1. Scopul colectării acestor date
						<br />
						Aceste informații sunt prelucrate &icirc;n scopul:
					</p>
					<p>
						&icirc;mbunătățirii funcționalității și securității website-ului;
						<br /> diagnosticării problemelor de funcționare ale serverului;
						<br /> administrării eficiente a platformei web;
						<br /> analizării comportamentului vizitatorilor și a traficului general (ex. prin
						instrumente de analiză web);
						<br /> obținerii de date statistice și demografice agregate care ne ajută să
						&icirc;nțelegem mai bine preferințele utilizatorilor și să optimizăm experiența de
						navigare.
						<br />
						4.2. Temeiul legal al prelucrării
						<br />
						Prelucrarea acestor date se realizează &icirc;n temeiul:
					</p>
					<p>
						Art. 6 alin. (1) lit. f GDPR &ndash; interesul legitim al All Consulting de a asigura
						funcționarea corespunzătoare, securitatea și &icirc;mbunătățirea experienței
						utilizatorilor pe website-ul său.
						<br />
						5. TEMEIURILE LEGALE ALE PRELUCRĂRII DATELOR CU CARACTER PERSONAL
						<br />
						Prelucrarea datelor dumneavoastră cu caracter personal de către All Consulting se realizează
						&icirc;n conformitate cu dispozițiile Regulamentului (UE) 2016/679 (GDPR) și are la bază
						următoarele temeiuri legale:
					</p>
					<p>
						a) Executarea unui contract sau demersuri precontractuale
						<br />
						Conform art. 6 alin. (1) lit. b GDPR, prelucrăm datele necesare pentru:
					</p>
					<p>
						&icirc;nregistrarea &icirc;n aplicație;
						<br /> completarea și transmiterea declarației fiscale;
						<br /> furnizarea de asistență tehnică;
						<br /> procesarea plăților aferente serviciilor contractate.
						<br />
						b) &Icirc;ndeplinirea unei obligații legale
						<br />
						&Icirc;n baza art. 6 alin. (1) lit. c GDPR, prelucrăm anumite date pentru:
					</p>
					<p>
						respectarea legislației contabile, fiscale sau de arhivare (ex. păstrarea datelor
						tranzacționale timp de 10 ani);
						<br /> răspunsuri către autorități sau instituții publice, conform obligațiilor legale
						aplicabile.
						<br />
						c) Consimțăm&acirc;ntul expres al persoanei vizate
						<br />
						&Icirc;n temeiul art. 6 alin. (1) lit. a GDPR (și, dacă este cazul, art. 9 alin. (2) lit.
						a GDPR), prelucrăm date &icirc;n scopuri precum:
					</p>
					<p>
						transmiterea de comunicări comerciale personalizate (marketing direct);
						<br /> conectarea prin conturi de social media (ex: Facebook, Instagram, TikTok);
						<br /> anumite funcționalități suplimentare din aplicație care necesită acordul explicit
						al utilizatorului.
						<br />
						Consimțăm&acirc;ntul poate fi retras &icirc;n orice moment, fără a afecta legalitatea
						prelucrărilor efectuate anterior retragerii.
					</p>
					<p>
						d) Interesul legitim al Operatorului
						<br />
						&Icirc;n baza art. 6 alin. (1) lit. f GDPR, All Consulting poate prelucra date &icirc;n
						scopul:
					</p>
					<p>
						&icirc;mbunătățirii aplicației și experienței utilizatorilor;
						<br /> prevenției fraudelor și asigurării securității aplicației;
						<br /> analizării comportamentului de utilizare pentru &icirc;mbunătățirea serviciilor;
						<br /> comunicării cu clienții existenți &icirc;n limitele permise de lege.
						<br />
						&Icirc;n toate cazurile &icirc;n care ne bazăm pe interesul nostru legitim, ne asigurăm că
						acest interes nu prevalează asupra drepturilor și libertăților fundamentale ale
						persoanelor vizate.
					</p>
					<p>
						6. MODALITATEA DE PRELUCRARE A DATELOR
						<br />
						6.1. Prelucrarea și divulgarea datelor către terți
						<br />
						All Consulting poate colecta, accesa, stoca, modifica, transfera sau divulga datele cu
						caracter personal ale Clientului către terți &icirc;n următoarele condiții:
					</p>
					<p>
						6.1.1. &Icirc;n scopul executării Contractului
						<br />
						Prelucrarea este realizată &icirc;n conformitate cu obiectul Contractului și
						instrucțiunile rezonabile ale Clientului, inclusiv, dacă este cazul, transferul datelor
						către o țară terță sau o organizație internațională, &icirc;n măsura &icirc;n care acest
						lucru este necesar pentru prestarea serviciilor asumate prin Contract.
					</p>
					<p>
						6.1.2. &Icirc;n baza unei obligații legale
						<br />
						Dacă legislația aplicabilă impune divulgarea unor date cu caracter personal, All Consulting va
						notifica Clientul (&icirc;n măsura &icirc;n care acest lucru este permis de lege) cu
						privire la solicitarea respectivă, anterior divulgării efective a datelor.
					</p>
					<p>
						6.2. &Icirc;ncălcarea securității datelor
						<br />
						&Icirc;n situația &icirc;n care All Consulting ia cunoștință de o &icirc;ncălcare a
						securității datelor cu caracter personal, aceasta:
					</p>
					<p>
						6.2.1. Va informa de &icirc;ndată Clientul despre incident;
						<br />
						6.2.2. Va coopera cu Clientul și va &icirc;ntreprinde toate măsurile rezonabile pentru a
						investiga, atenua și remedia incidentul.
						<br />
						Dacă incidentul nu este imputabil All Consulting, Clientul va rambursa costurile rezonabile
						suportate pentru aceste măsuri (inclusiv resurse interne și servicii externe
						specializate).
					</p>
					<p>
						6.3. Măsuri tehnice și organizatorice
						<br />
						All Consulting va implementa măsurile tehnice și organizatorice adecvate, menționate &icirc;n
						Art. 10 din prezenta Politică, pe care Clientul le recunoaște ca fiind conforme și
						suficiente pentru a asigura un nivel corespunzător de protecție a datelor.
					</p>
					<p>
						6.4. Confidențialitatea personalului
						<br />
						All Consulting se va asigura că angajații, colaboratorii sau alți reprezentanți implicați
						&icirc;n prelucrarea datelor Clientului sunt supuși unor obligații contractuale, legale
						sau profesionale de confidențialitate.
					</p>
					<p>
						6.5. Evaluarea impactului și consultări prealabile
						<br />
						All Consulting va sprijini Clientul, atunci c&acirc;nd este cazul, &icirc;n:
					</p>
					<p>
						efectuarea evaluărilor de impact privind protecția datelor conform art. 35 GDPR;
						<br /> realizarea de consultări prealabile cu autoritățile de supraveghere conform art. 36
						GDPR.
						<br />
						Dacă nu există o cerință legală contrară, All Consulting va &icirc;nceta prelucrarea datelor
						personale ale Clientului &icirc;n termen de maximum 60 de zile de la &icirc;ncetarea
						serviciilor.
					</p>
					<p>
						Totuși, All Consulting are dreptul să păstreze anumite date personale pentru o perioadă de 5
						ani (denumită &bdquo;Durata de retenție&rdquo;) &icirc;n scopul protejării intereselor
						sale legitime, &icirc;n special &icirc;n contextul apărării &icirc;ntr-un eventual
						litigiu. Pe durata retenției:
					</p>
					<p>
						Datele vor fi criptate, pseudonimizate sau arhivate;
						<br /> Accesul la acestea va fi restricționat;
						<br /> După expirarea perioadei, datele vor fi șterse definitiv sau returnate Clientului,
						după caz.
						<br />
						6.6. Utilizarea subcontractanților
						<br />
						Clientul autorizează All Consulting să apeleze la subcontractanții autorizați pentru
						prelucrarea datelor cu caracter personal, &icirc;n următoarele condiții:
					</p>
					<p>
						6.6.1. Informare prealabilă
						<br />
						All Consulting va notifica Clientul (prin e-mail sau alt canal convenit) &icirc;n legătură cu
						intenția de a colabora cu un nou subcontractant care va avea acces la datele Clientului.
					</p>
					<p>
						6.6.2. Condiții contractuale
						<br />
						All Consulting va &icirc;ncheia cu fiecare subcontractant un contract care conține clauze
						echivalente celor din prezenta Politică, respect&acirc;nd cerințele art. 28 GDPR.
					</p>
					<p>
						6.6.3. Răspundere
						<br />
						&Icirc;n cazul &icirc;n care subcontractantul nu respectă obligațiile sale privind
						protecția datelor, All Consulting răm&acirc;ne pe deplin răspunzătoare față de Client pentru
						orice prejudiciu cauzat.
					</p>
					<p>
						6.6.4. Drept de opoziție
						<br />
						Clientul are dreptul să formuleze o obiecție justificată cu privire la subcontractantul
						propus, &icirc;n termen de 30 de zile calendaristice de la data notificării. &Icirc;n
						acest caz, părțile vor depune eforturi de bună-credință pentru a identifica o soluție
						alternativă &icirc;n următoarele 30 de zile. Dacă nu se ajunge la un acord, All Consulting
						&icirc;și rezervă dreptul de a denunța unilateral Contractul, cu notificare prealabilă.
					</p>
					<p>
						7. DURATA DE PRELUCRARE A DATELOR CU CARACTER PERSONAL
						<br />
						7.1. Perioada de stocare
						<br />
						Datele cu caracter personal colectate de All Consulting sunt păstrate pe durata necesară
						atingerii scopurilor pentru care au fost colectate, inclusiv pentru executarea
						contractului și furnizarea serviciilor solicitate de Client.
					</p>
					<p>După atingerea scopului, datele sunt:</p>
					<p>
						șterse;
						<br /> anonimizate;
						<br /> sau arhivate, dacă este cazul, conform politicilor interne și legislației
						aplicabile.
						<br />
						7.2. Obligații legale de păstrare
						<br />
						&Icirc;n anumite cazuri, păstrarea datelor este necesară chiar și după &icirc;ncetarea
						relației contractuale, &icirc;n baza unor obligații legale specifice, cum ar fi:
					</p>
					<p>
						păstrarea documentelor contabile și fiscale (ex: facturi, tranzacții);
						<br /> obligații de arhivare &icirc;n temeiul legislației din Rom&acirc;nia, Germania sau
						alte jurisdicții aplicabile.
						<br />
						Temeiul juridic este art. 6 alin. (1) lit. c GDPR &ndash; &icirc;ndeplinirea unei
						obligații legale.
					</p>
					<p>
						7.3. Păstrarea pe baza interesului legitim
						<br />
						&Icirc;n lipsa unei obligații legale concrete, All Consulting poate păstra anumite date cu
						caracter personal pentru o perioadă de maximum 5 ani de la &icirc;ncetarea
						serviciului/contractului, &icirc;n temeiul art. 6 alin. (1) lit. f GDPR &ndash; interes
						legitim, exclusiv &icirc;n următoarele scopuri:
					</p>
					<p>
						constatarea, exercitarea sau apărarea unui drept &icirc;n justiție;
						<br /> gestionarea eventualelor reclamații sau dispute privind serviciile prestate.
						<br />
						Pe durata acestei &bdquo;perioade de retenție&rdquo;, datele:
					</p>
					<p>
						vor fi stocate separat de cele utilizate activ;
						<br /> vor fi criptate și/sau pseudonimizate;
						<br /> vor fi accesate numai dacă este necesar &icirc;ntr-un context legal sau litigios.
						<br />
						După expirarea acestei perioade, datele vor fi:
					</p>
					<p>
						șterse &icirc;n mod definitiv;
						<br /> sau, la cererea Clientului, returnate &icirc;n formă lizibilă, dacă este posibil
						tehnic și legal.
						<br />
						8. DIVULGAREA DATELOR CU CARACTER PERSONAL
						<br />
						8.1. Destinatarii datelor
						<br />
						&Icirc;n vederea executării contractului și &icirc;ndeplinirii obligațiilor legale, datele
						dumneavoastră cu caracter personal pot fi divulgate sau transmise următorilor destinatari
						sau categorii de destinatari:
					</p>
					<p>
						Autorități fiscale din Germania, inclusiv:
						<br /> Finanzamt (biroul fiscal german);
						<br /> Familienkasse (agenția responsabilă de plata alocațiilor pentru copii);
						<br /> Alte autorități publice sau instituții competente, atunci c&acirc;nd divulgarea
						este impusă de o dispoziție legală națională sau europeană.
						<br />
						Transferul datelor &icirc;n scopul menționat mai sus se realizează către țări membre ale
						Uniunii Europene (&icirc;n special Germania), &icirc;n condiții de conformitate cu
						dispozițiile Capitolului V din GDPR. Prin &icirc;ncheierea contractului, Clientul
						&icirc;și exprimă acordul explicit privind astfel de transferuri, &icirc;n măsura &icirc;n
						care sunt necesare pentru executarea serviciilor contractate.
					</p>
					<p>
						8.2. Persoane &icirc;mputernicite și colaboratori
						<br />
						Datele personale pot fi accesate sau prelucrate, &icirc;n limitele strict necesare, și de:
					</p>
					<p>
						angajați și consultanți ai All Consulting implicați &icirc;n furnizarea serviciilor;
						<br /> colaboratori sau contractori externi (inclusiv experți fiscali și furnizori IT);
						<br /> persoane &icirc;mputernicite (subcontractanți GDPR), conform art. 28 din GDPR, care
						acționează &icirc;n numele și pe seama All Consulting, &icirc;n baza unor contracte ce asigură
						un nivel echivalent de protecție a datelor.
						<br />
						Toate aceste entități sunt supuse obligațiilor legale sau contractuale de
						confidențialitate și au acces limitat la datele cu caracter personal, doar &icirc;n măsura
						necesară prestării serviciilor respective.
					</p>
					<p>
						9. TRANSFERUL DATELOR CU CARACTER PERSONAL CĂTRE STATE TERȚE
						<br />
						9.1. Principii generale
						<br />
						All Consulting poate transfera date cu caracter personal către o țară terță (din afara
						Spațiului Economic European &ndash; SEE) sau către o organizație internațională numai
						&icirc;n condițiile permise de GDPR, iar astfel de transferuri vor fi efectuate cu
						respectarea cerințelor de legalitate, necesitate și proporționalitate.
					</p>
					<p>
						Aceste reguli se aplică inclusiv transferurilor ulterioare efectuate de o persoană
						&icirc;mputernicită de All Consulting către alți operatori sau persoane &icirc;mputernicite
						aflate &icirc;n afara SEE.
					</p>
					<p>
						9.2. Transferuri pe baza unei decizii de adecvare - Art. 44-50 GDPR
						<br />
						Transferul datelor cu caracter personal către o țară terță sau o organizație
						internațională se poate realiza fără a fi necesare garanții suplimentare, dacă Comisia
						Europeană a adoptat, &icirc;n temeiul articolului 45 din GDPR, o decizie de adecvare prin
						care constată că acea țară, teritoriu sau organizație asigură un nivel de protecție
						adecvat, echivalent cu cel garantat &icirc;n Uniunea Europeană.
						<br />
						9.3. Transferuri &icirc;n baza unor garanții adecvate
						<br />
						&Icirc;n lipsa unei decizii de adecvare, transferurile pot fi efectuate numai dacă
						All Consulting sau, după caz, persoana &icirc;mputernicită, asigură garanții adecvate, prin:
					</p>
					<p>
						clauze contractuale standard aprobate de Comisia Europeană;
						<br /> reguli corporatiste obligatorii (Binding Corporate Rules &ndash; BCR);
						<br /> coduri de conduită aprobate, &icirc;nsoțite de angajamente executorii;
						<br /> mecanisme de certificare aprobate conform art. 42 GDPR, &icirc;nsoțite de
						angajamente executorii;
						<br /> acorduri obligatorii &icirc;ntre autorități publice;
						<br /> clauze contractuale aprobate de o autoritate de supraveghere și validate de Comisia
						Europeană.
						<br />
						&Icirc;n toate aceste cazuri, All Consulting se va asigura că sunt respectate drepturile
						persoanelor vizate și se oferă un nivel echivalent de protecție cu cel garantat &icirc;n
						Uniunea Europeană.
					</p>
					<p>
						9.4. Transferuri &icirc;n absența unor garanții adecvate
						<br />
						Dacă nu există o decizie de adecvare și nici garanții suficiente, un transfer de date
						către o țară terță poate avea loc doar &icirc;n circumstanțe excepționale, prevăzute la
						art. 49 GDPR, cum ar fi:
					</p>
					<p>
						persoana vizată și-a exprimat acordul expres și informat privind transferul propus, după
						ce a fost informată cu privire la riscurile implicate;
						<br /> transferul este necesar pentru executarea unui contract &icirc;ncheiat &icirc;ntre
						persoana vizată și All Consulting sau pentru aplicarea unor măsuri precontractuale la cererea
						acesteia;
						<br /> transferul este necesar pentru executarea unui contract &icirc;ncheiat &icirc;n
						interesul persoanei vizate &icirc;ntre All Consulting și o altă entitate (fizică sau
						juridică);
						<br /> transferul este necesar pentru constatarea, exercitarea sau apărarea unui drept
						&icirc;n justiție.
						<br />
						10. DREPTURILE PERSOANEI VIZATE (CLIENTULUI)
						<br />
						&Icirc;n calitate de persoană vizată, beneficiați de următoarele drepturi garantate de
						Regulamentul (UE) 2016/679 (GDPR):
					</p>
					<p>
						10.1. Drepturi privind prelucrarea datelor
						<br />▪ Dreptul de acces &ndash; Art. 15 GDPR
						<br />
						Aveți dreptul de a obține din partea All Consulting o confirmare că datele dvs. sunt sau nu
						prelucrate, iar &icirc;n caz afirmativ, acces la informații privind:
					</p>
					<p>
						scopurile prelucrării;
						<br /> categoriile de date vizate;
						<br /> destinatarii sau categoriile de destinatari (inclusiv din țări terțe sau
						organizații internaționale);
						<br /> perioada de stocare sau criteriile de determinare;
						<br /> existența drepturilor de rectificare, ștergere, restricționare sau opoziție;
						<br /> sursa datelor, dacă nu au fost colectate direct de la dvs.;
						<br /> existența unui proces decizional automatizat, inclusiv crearea de profiluri;
						<br /> garanțiile pentru transferurile internaționale.
						<br />▪ Dreptul la rectificare &ndash; Art. 16 GDPR
						<br />
						Aveți dreptul de a solicita corectarea datelor personale inexacte sau completarea datelor
						incomplete, inclusiv printr-o declarație suplimentară, fără &icirc;nt&acirc;rzieri
						nejustificate.
					</p>
					<p>
						▪ Dreptul la ștergere (&bdquo;dreptul de a fi uitat&rdquo;) &ndash; Art. 17 GDPR
						<br />
						Puteți solicita ștergerea datelor dvs. personale atunci c&acirc;nd:
					</p>
					<p>
						datele nu mai sunt necesare pentru scopurile pentru care au fost colectate;
						<br /> v-ați retras consimțăm&acirc;ntul și nu există alt temei legal;
						<br /> vă opuneți prelucrării și nu există motive legitime care să prevaleze;
						<br /> datele au fost prelucrate ilegal;
						<br /> există o obligație legală de ștergere.
						<br />▪ Dreptul la restricționare &ndash; Art. 18 GDPR
						<br />
						Aveți dreptul să solicitați restricționarea prelucrării &icirc;n următoarele cazuri:
					</p>
					<p>
						contestați exactitatea datelor;
						<br /> prelucrarea este ilegală, dar nu doriți ștergerea;
						<br /> All Consulting nu mai are nevoie de date, dar dvs. le solicitați pentru un drept
						&icirc;n instanță;
						<br /> v-ați opus prelucrării și se așteaptă verificarea prevalenței intereselor.
						<br />▪ Dreptul la portabilitate &ndash; Art. 20 GDPR
						<br />
						Aveți dreptul să primiți datele personale furnizate, &icirc;ntr-un format structurat,
						utilizat &icirc;n mod curent și care poate fi citit automat, și să le transmiteți altui
						operator, dacă:
					</p>
					<p>
						prelucrarea se bazează pe consimțăm&acirc;nt sau pe un contract;
						<br /> prelucrarea este realizată prin mijloace automate.
						<br />▪ Dreptul la opoziție &ndash; Art. 21 GDPR
						<br />
						Aveți dreptul de a vă opune, din motive legate de situația dvs. particulară, prelucrării
						efectuate &icirc;n temeiul interesului legitim al All Consulting sau &icirc;n scopul
						interesului public, inclusiv profilării. Vom &icirc;nceta prelucrarea, cu excepția cazului
						&icirc;n care demonstrăm un interes legitim superior sau este necesară pentru apărarea
						unui drept &icirc;n instanță.
					</p>
					<p>
						▪ Dreptul de opoziție la marketing direct
						<br />
						Aveți dreptul să vă opuneți oric&acirc;nd prelucrării &icirc;n scopuri de marketing
						direct, inclusiv profilării, fără nicio justificare.
					</p>
					<p>
						▪ Dreptul de retragere a consimțăm&acirc;ntului &ndash; Art. 7(3) GDPR
						<br />
						Dacă prelucrarea se bazează pe consimțăm&acirc;nt, &icirc;l puteți retrage &icirc;n orice
						moment, fără a afecta legalitatea prelucrării efectuate anterior retragerii.
					</p>
					<p>
						10.2. Dreptul de a depune o pl&acirc;ngere
						<br />
						Dacă considerați că drepturile dvs. au fost &icirc;ncălcate, puteți depune o
						pl&acirc;ngere la:
					</p>
					<p>
						Autoritatea Națională de Supraveghere a Prelucrării Datelor cu Caracter Personal
						<br />
						B-dul G-ral Gheorghe Magheru nr. 28-30, Sector 1, cod poștal 010336, București,
						Rom&acirc;nia
						<br />
						📞 Tel: 031 805 9211
						
					</p>
					<p>
						Totodată, vă &icirc;ncurajăm să ne contactați &icirc;nainte de a trimite o pl&acirc;ngere
						oficială, iar noi vom depune toate eforturile pentru a soluționa problema pe cale
						amiabilă.
					</p>
					<p>
						10.3. Retragerea consimțăm&acirc;ntului &icirc;n scopuri de marketing
						<br />
						Puteți retrage consimțăm&acirc;ntul pentru primirea de comunicări comerciale (newslettere,
						oferte) &icirc;n orice moment, fără justificare, printr-un simplu mesaj transmis:
					</p>
					<p>
						prin e-mail la: [contact@all-consulting-lascu.ro];
						<br /> sau prin opțiunile de dezabonare disponibile &icirc;n mesajele noastre.
						<br />
						10.4. Exercitarea drepturilor
						<br />
						Pentru exercitarea oricăruia dintre drepturile menționate, ne puteți contacta:
					</p>
					<p>
						📍 Prin poștă:
						<br />
						ALL CONSULTING LASCU S.R.L.
						<br /> mun. Sibiu, Cisnadie, Str. Grigore Ionescu 2 Ap. 2C Cod 555300
						Rom&acirc;nia,
					</p>
					<p>📧 Prin e-mail: [contact@all-consulting-lascu.ro]</p>
					<p>
						Solicitarea trebuie să fie scrisă, datată și semnată (electronic sau fizic). Vom răspunde
						&icirc;n termenul legal prevăzut de GDPR (30 de zile de la primirea cererii).
					</p>
					<p>
						10.5. Obligația de furnizare a datelor
						<br />
						Furnizarea anumitor date cu caracter personal este necesară pentru &icirc;ncheierea și
						executarea Contractului. Refuzul de a furniza aceste date poate conduce la imposibilitatea
						prestării serviciilor de către All Consulting.
					</p>
					<p>
						11. AUTORIZĂRILE SOLICITATE LA UTILIZAREA APLICAȚIEI
						<br />
						Pentru a oferi funcționalitățile esențiale ale aplicației mobile All Consulting, este posibil
						să vă solicităm acces la anumite funcții sau date ale dispozitivului mobil. Permisiunile
						sunt solicitate doar &icirc;n momentul &icirc;n care utilizarea acestor funcții este
						necesară, iar accesul se face exclusiv &icirc;n scopurile descrise mai jos.
					</p>
					<p>
						11.1. Dispozitive iOS (Apple)
						<br />▪ Notificări Push
						<br />
						La prima deschidere a aplicației, vi se va solicita acordul pentru a primi notificări push
						legate de termene importante fiscale, actualizări sau mesaje utile.
						<br />
						Accesul este voluntar și poate fi gestionat oric&acirc;nd &icirc;n:
					</p>
					<p>Setări &gt; Notificări &gt; All Consulting</p>
					<p>Temei legal: art. 6 alin. (1) lit. a GDPR &ndash; consimțăm&acirc;nt.</p>
					<p>
						▪ Acces la Cameră și Fotografii
						<br />
						Este necesar pentru:
					</p>
					<p>
						fotografierea documentelor (ex. fișe de salariu, carte de identitate);
						<br /> &icirc;ncărcarea de imagini din galeria dispozitivului pentru completarea cererii
						fiscale.
						<br />
						Permisiunile pot fi ajustate oric&acirc;nd &icirc;n:
					</p>
					<p>Setări &gt; Confidențialitate &gt; Cameră / Fotografii</p>
					<p>
						Aplicația procesează doar imaginile selectate de utilizator. Nu există acces continuu sau
						&icirc;n fundal la cameră sau galerie.
					</p>
					<p>Temei legal: art. 6 alin. (1) lit. b GDPR &ndash; executarea contractului.</p>
					<p>
						11.2. Dispozitive Android
						<br />▪ Notificări Push
						<br />
						La instalare, aplicația solicită permisiunea de a afișa notificări push despre starea
						cererii fiscale sau mesaje utile.
						<br />
						Setările pot fi modificate oric&acirc;nd &icirc;n:
					</p>
					<p>Setări &gt; Aplicații &gt; All Consulting &gt; Notificări</p>
					<p>
						▪ Acces la rețea (Internet)
						<br />
						Această permisiune permite aplicației să transmită datele completate către serverele
						All Consulting, prin conexiunea la internet (Wi-Fi sau date mobile).
						<br />
						Este esențială pentru:
					</p>
					<p>
						procesul de &icirc;nregistrare;
						<br /> completarea și trimiterea declarației fiscale.
						<br />
						Temei legal: art. 6 alin. (1) lit. b GDPR &ndash; executarea contractului.
					</p>
					<p>
						▪ Acces la Cameră
						<br />
						Solicitat atunci c&acirc;nd utilizatorul dorește să fotografieze documente direct din
						aplicație.
						<br />
						Accesul nu este activat automat și este controlat de utilizator &icirc;n mod expres.
					</p>
					<p>
						▪ Acces la stocare locală (memorie internă / card SD)
						<br />
						Utilizat pentru:
					</p>
					<p>
						salvarea temporară a fișierelor necesare completării declarației;
						<br /> accesarea fișierelor generate de aplicație (ex: .PDF, documente fiscale).
						<br />
						Aplicația accesează doar fișierele generate &icirc;n contextul utilizării serviciilor
						All Consulting. Nu accesează alte fișiere personale de pe dispozitiv.
					</p>
					<p>
						11.3. Garanții privind confidențialitatea
						<br /> Permisiunile sunt solicitate doar &icirc;n momentul utilizării funcționalității
						respective, nu &icirc;n avans.
						<br /> Nu sunt colectate informații suplimentare față de cele furnizate voluntar de
						utilizator.
						<br /> Orice permisiune acordată poate fi revocată oric&acirc;nd din setările telefonului.
						<br />
						12. MĂSURI TEHNICE ȘI ORGANIZATORICE
						<br />
						All Consulting implementează măsuri tehnice și organizatorice adecvate pentru a asigura un
						nivel corespunzător de securitate a datelor cu caracter personal prelucrate, &icirc;n
						conformitate cu articolul 32 din Regulamentul (UE) 2016/679 (GDPR). Aceste măsuri includ,
						fără a se limita la:
					</p>
					<p>
						12.1. Identificarea și autentificarea utilizatorilor
						<br /> Accesul la date este permis doar utilizatorilor autorizați de All Consulting;
						<br /> Fiecare utilizator are un cont unic de acces (user + parolă);
						<br /> Parolele sunt complexe și se modifică periodic;
						<br /> Accesul este blocat automat după 5 &icirc;ncercări greșite;
						<br /> Codurile de autentificare sunt strict confidențiale, iar utilizatorii sunt
						instruiți și responsabili pentru protejarea lor;
						<br /> Accesul este revocat imediat &icirc;n caz de demisie, concediere sau schimbare a
						funcției.
						<br />
						12.2. Limitarea accesului
						<br /> Utilizatorii au acces doar la datele strict necesare pentru &icirc;ndeplinirea
						atribuțiilor;
						<br /> Echipa de suport tehnic poate accesa date doar &icirc;n situații excepționale și
						bine documentate;
						<br /> Se aplică principiul &bdquo;need to know&rdquo; și minimizarea accesului.
						<br />
						12.3. Colectarea și modificarea datelor
						<br /> Doar utilizatori desemnați pot colecta, introduce sau modifica datele personale
						&icirc;n sistem;
						<br /> Orice intervenție asupra datelor este auditată.
						<br />
						12.4. Copii de siguranță (backup)
						<br /> Copiile de siguranță sunt efectuate la intervale regulate, conform unei politici
						interne;
						<br /> Backup-urile sunt criptate și stocate &icirc;n medii securizate;
						<br /> Accesul la operațiuni de backup este restricționat unui număr limitat de persoane
						autorizate.
						<br />
						12.5. Securitatea fizică a echipamentelor
						<br /> Dispozitivele (servere, computere, terminale de acces) sunt amplasate &icirc;n
						spații securizate;
						<br /> Accesul fizic este permis doar personalului autorizat, pe bază de cartelă magnetică
						sau cheie.
						<br />
						12.6. Monitorizarea accesului (loguri)
						<br /> Fiecare acces la datele personale este &icirc;nregistrat &icirc;ntr-un fișier de
						log (automat) sau registru (manual);
						<br /> Logurile conțin: utilizatorul, data, ora, acțiunea efectuată;
						<br /> Se păstrează pentru audit intern și controlul integrității sistemului.
						<br />
						12.7. Securitatea rețelelor și telecomunicațiilor
						<br /> Se efectuează periodic controale ale autentificărilor și nivelurilor de acces;
						<br /> Se monitorizează traficul pentru detectarea tentativelor de acces neautorizat sau
						disfuncționalități tehnice.
						<br />
						12.8. Instruirea personalului
						<br /> Toți angajații și colaboratorii sunt instruiți periodic privind:
						<br /> prevederile legale aplicabile &icirc;n domeniul protecției datelor;
						<br /> obligațiile de confidențialitate;
						<br /> riscurile asociate prelucrării datelor;
						<br /> Instruirile sunt documentate și actualizate conform noilor reglementări.
						<br />
						12.9. Măsuri IT &icirc;mpotriva amenințărilor informatice
						<br /> Este interzisă utilizarea de software neautorizat sau din surse externe;
						<br /> Sistemele sunt protejate cu antivirus, firewall și soluții avansate de securitate;
						<br /> Se aplică actualizări de securitate &icirc;n mod regulat pentru sistemele
						utilizate;
						<br /> Infrastructura IT este supusă testărilor periodice de vulnerabilitate.
						<br />
						13. SUBCONTRACTANȚI AUTORIZAȚI
						<br />
						13.1. Acceptarea subcontractării
						<br />
						All Consulting poate apela la terți (subcontractanți) pentru &icirc;ndeplinirea unor obligații
						care decurg din executarea contractului, cu respectarea prevederilor legale și a
						principiilor de protecție a datelor cu caracter personal.
					</p>
					<p>
						13.2. Definirea subcontractării
						<br />
						Subcontractarea reprezintă soluția legală prin care anumite sarcini sau activități asumate
						de All Consulting &icirc;n cadrul relației contractuale pot fi delegate către o terță parte
						&ndash; numită subcontractant &ndash; cu scopul de a asigura continuitatea, eficiența și
						specializarea serviciilor oferite Clientului.
					</p>
					<p>
						Toți subcontractanții All Consulting care prelucrează date cu caracter personal acționează
						exclusiv &icirc;n numele și pe seama All Consulting, &icirc;n calitate de persoane
						&icirc;mputernicite conform art. 28 din GDPR.
					</p>
					<p>
						13.3. Garanții oferite privind personalul
						<br />
						All Consulting garantează că at&acirc;t personalul propriu, c&acirc;t și cel al oricărui
						subcontractant:
					</p>
					<p>
						deține calificările, instruirea și experiența profesională necesare pentru executarea
						&icirc;n mod corespunzător a sarcinilor atribuite;
						<br /> este supus obligațiilor contractuale de confidențialitate;
						<br /> acționează exclusiv &icirc;n cadrul instrucțiunilor primite de la All Consulting și
						&icirc;n conformitate cu cerințele GDPR.
						<br />
						All Consulting răm&acirc;ne pe deplin responsabilă pentru orice act sau omisiune a
						subcontractanților implicați &icirc;n prelucrarea datelor personale ale Clientului.
					</p>
					<p>
						14. LEGISLAȚIE ȘI PROCEDURI APLICABILE
						<br />
						Prezenta Politică de Confidențialitate este elaborată &icirc;n conformitate cu legislația
						națională și europeană &icirc;n vigoare privind protecția datelor cu caracter personal și
						se completează cu următoarele acte normative și documente interne relevante:
					</p>
					<p>
						14.1. Legislație europeană și națională aplicabilă
						<br /> Regulamentul (UE) 2016/679 (GDPR) privind protecția persoanelor fizice &icirc;n
						ceea ce privește prelucrarea datelor cu caracter personal și libera circulație a acestor
						date;
						<br /> Legea nr. 506/2004 privind prelucrarea datelor cu caracter personal și protecția
						vieții private &icirc;n sectorul comunicațiilor electronice;
						<br /> Regulamentul (UE) nr. 611/2013 privind măsurile aplicabile notificării
						&icirc;ncălcărilor securității datelor cu caracter personal &icirc;n temeiul Directivei
						2002/58/CE;
						<br /> Deciziile, ordinele și recomandările emise de Autoritatea Națională de Supraveghere
						a Prelucrării Datelor cu Caracter Personal (ANSPDCP);
						<br /> Orice alte acte normative prezente sau viitoare, aplicabile &icirc;n Rom&acirc;nia
						sau la nivelul Uniunii Europene, care reglementează prelucrarea și protecția datelor cu
						caracter personal.
						<br />
						14.2. Surse de orientare și bune practici
						<br /> Ghidurile emise de Grupul de Lucru pentru protecția datelor &ndash; Articolul 29
						(WP29) și/sau de Comitetul European pentru Protecția Datelor (EDPB);
						<br /> Decizii ale Curții de Justiție a Uniunii Europene (CJUE) relevante &icirc;n materia
						protecției datelor.
						<br />
						14.3. Documente interne All Consulting
						<br />
						Prezenta politică se aplică &icirc;mpreună cu următoarele politici și proceduri interne
						ale All Consulting:
					</p>
					<p>
						Politica de retenție a datelor cu caracter personal;
						<br /> Procedura internă privind gestionarea incidentelor de securitate (inclusiv
						notificarea &icirc;ncălcărilor conform GDPR);
						<br /> Contractele de prelucrare a datelor &icirc;ncheiate cu subcontractanți / persoane
						&icirc;mputernicite;
						<br /> Orice altă politică internă existentă sau viitoare a All Consulting privind protecția
						datelor, integritatea informației și conformitatea GDPR.
						<br />
						15. LIMITELE RĂSPUNDERII ALL-CONSULTING-LASCU.RO
						<br />
						15.1. Limitare instituțională
						<br />
						ALL-CONSULTING-LASCU.RO este o platformă digitală operată de ALL CONSULTING LASCU S.R.L., o entitate
						juridică privată, și nu este afiliată, mandatată sau reprezentantă a vreunei instituții
						guvernamentale, autorități publice sau entități politice din Rom&acirc;nia, Germania sau
						din orice alt stat.
					</p>
					<p>
						Aplicația și serviciile oferite nu constituie și nu &icirc;nlocuiesc serviciile furnizate
						de autoritățile fiscale sau de orice altă instituție publică.
					</p>
					<p>
						15.2. Limitare profesională
						<br />
					     ALL-CONSULTING-LASCU.RO nu oferă servicii de consultanță fiscală, contabilitate sau reprezentare
						juridică specializată. Toate informațiile furnizate prin intermediul aplicației sau prin
						suportul tehnic sunt strict informative, generale și orientative.
					</p>
					<p>
						Utilizatorii sunt &icirc;ncurajați să se adreseze unor consultanți fiscali autorizați
						pentru &icirc;ntrebări sau soluții specifice privind situația lor fiscală personală.
					</p>
					<p>
						16. CLAUZE FINALE
						<br />
						16.1. &Icirc;ncetarea aplicabilității
						<br />
						Prezenta Anexă privind protecția datelor personale va &icirc;nceta de plin drept:
					</p>
					<p>
						odată cu &icirc;ncetarea Contractului principal dintre Client și ALL-CONSULTING-LASCU.RO;
						<br /> sau odată cu finalizarea tuturor serviciilor aferente Contractului,
						<br />
						&mdash; oricare dintre aceste momente survenind la o dată ulterioară.
						<br />
						16.2. Legea aplicabilă
						<br />
						Această Anexă este guvernată de legislația &icirc;n vigoare din Rom&acirc;nia, statul
						membru al Uniunii Europene &icirc;n care ALL-CONSULTING-LASCU.RO &icirc;și are sediul social.
					</p>
					<p>
						16.3. Nulitatea parțială
						<br />
						&Icirc;n cazul &icirc;n care o prevedere din prezenta Anexă este declarată nulă,
						inaplicabilă sau lipsită de efect, aceasta nu va afecta valabilitatea celorlalte
						prevederi, care răm&acirc;n &icirc;n vigoare și &icirc;și păstrează efectele juridice.
					</p>
					<p>
						Prevederea afectată va fi interpretată sau modificată, pe c&acirc;t posibil, pentru a
						reflecta intenția părților și pentru a păstra valabilitatea juridică a documentului
						&icirc;n ansamblu;
						<br /> &Icirc;n caz contrar, se va considera că acea clauză nu a existat, fără a afecta
						restul Anexei.
						<br />
						Prezenta Anexă privind protecția datelor personale completează toate contractele
						&icirc;ncheiate &icirc;ntre ALL-CONSULTING-LASCU.RO și clienții săi, &icirc;ncep&acirc;nd cu data de
						28 august 2023.
					</p>
				</div>
			</div>
		</>
	);
}
